import { createFlagsHook } from '@omnea-app/fe-org-settings/createFlagsHook'

export const useAppShellLdFlags = createFlagsHook<typeof import('./flags.json')>()
